import { Component, HostBinding, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AlertType } from '@nibtravel/shared/ui/components/alert';
import { UiContextSelector } from '@nibtravel/shared/data-access/ui-context';

@Component({
  selector: 'nibtravel-qqc-alert',
  templateUrl: 'qqc-alert.component.html',
})
export class QqcAlertComponent implements OnInit {
  AlertType = AlertType;
  alertError$!: Observable<string | undefined>;

  @HostBinding('class') hostClass = 'qqc-alert';

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.alertError$ = this.store.select(UiContextSelector.qqcAlertMessage);
  }
}
